import axiosApi from '@klinx/utils/api/axios-api.js';

const apiList = {
  // 批量查询
  batchPage: {
    method: 'POST',
    url: `/authority/dictionary/query`
  },
  // 分页列表查询
  page: {
    method: 'POST',
    url: `/authority/dictionary/page`
  },
  // 修改
  update: {
    method: 'PUT',
    url: `/authority/dictionary`
  },
  // 新增
  save: {
    method: 'POST',
    url: `/authority/dictionary`
  },
  // 删除
  remove: {
    method: 'DELETE',
    url: `/authority/dictionary`
  },
  // 分页列表查询-字典列表
  pageType: {
    method: 'POST',
    url: `/authority/dictionary/pageType`
  },
  updateType: {
    method: 'PUT',
    url: `/authority/dictionary/type`
  },
  saveType: {
    method: 'POST',
    url: `/authority/dictionary/type`
  },
  deleteType: {
    method: 'DELETE',
    url: `/authority/dictionary/type`
  },
  codes: {
    method: 'GET',
    url: `/oauth/dictionary/codes`
  },
  // 字典分组列表
  list: {
    method: 'POST',
    url: `/authority/dictionary/listDictGroup`
  },
  // 导出字典信息
  export: {
    method: 'POST',
    url: `/authority/dictionary/export`
  },
  // 导入字典信息
  import: {
    method: 'POST',
    url: `/authority/dictionary/import`
  }
};

export default {
  codes(data) {
    return axiosApi({
      ...apiList.codes,
      data
    });
  },
  page(data) {
    return axiosApi({
      ...apiList.page,
      data
    });
  },
  save(data) {
    return axiosApi({
      ...apiList.save,
      data
    });
  },
  update(data) {
    return axiosApi({
      ...apiList.update,
      data
    });
  },
  remove(data) {
    return axiosApi({
      ...apiList.remove,
      data
    });
  },
  pageType(data) {
    return axiosApi({
      ...apiList.pageType,
      data
    });
  },
  saveType(data) {
    return axiosApi({
      ...apiList.saveType,
      data
    });
  },
  updateType(data) {
    return axiosApi({
      ...apiList.updateType,
      data
    });
  },
  deleteType(data) {
    return axiosApi({
      ...apiList.deleteType,
      data
    });
  },
  list(data) {
    return axiosApi({
      ...apiList.list,
      data
    });
  },
  export(data) {
    return axiosApi({
      ...apiList.export,
      responseType: 'blob',
      data
    });
  },
  import(data) {
    return axiosApi({
      ...apiList.import,
      data
    });
  },
  batchPage(data) {
    return axiosApi({
      ...apiList.batchPage,
      data
    });
  }
};
